import { useEffect, useState } from 'react';
import { getUserWeight } from '../../../api/reports.api';
import WeightChart from './components/WeightChart';

export default function WeightTab({ userId }) {
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      setLoading(true);
      const res = await getUserWeight(userId);
      setRecord(res.data.data || null);
    } catch (err) {
      console.error('Load weight error:', err);
    }
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  if (loading) return <p>در حال بارگذاری...</p>;

  if (!record) {
    return <p>قبلاً هیچ وزنی ثبت نشده است.</p>;
  }

  const { startingWeight, goalWeight, weightEntries } = record;

  const currentWeight = weightEntries[weightEntries.length - 1]?.weight;

  const lost = startingWeight - currentWeight;

  const progressPercent = Math.max(
    0,
    Math.min(
      100,
      ((startingWeight - currentWeight) / (startingWeight - goalWeight)) * 100
    )
  );

  return (
    <div className="space-y-6">
      {/* --- Summary Cards --- */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <SummaryCard title="وزن اولیه" value={`${startingWeight} kg`} />
        <SummaryCard title="وزن هدف" value={`${goalWeight} kg`} />
        <SummaryCard title="وزن فعلی" value={`${currentWeight} kg`} />
        <SummaryCard
          title="تغییر وزن"
          value={
            lost >= 0
              ? `${lost.toFixed(1)} kg -`
              : `+${Math.abs(lost.toFixed(1))} kg`
          }
        />
      </div>

      {/* --- Progress Bar --- */}
      <div className="bg-white p-4 rounded-xl shadow">
        <p className="font-bold mb-2">پیشرفت تا هدف</p>
        <div className="w-full bg-gray-200 rounded-full h-3">
          <div
            className="bg-green-500 h-3 rounded-full transition-all"
            style={{ width: `${progressPercent}%` }}></div>
        </div>
        <p className="text-sm mt-2 text-gray-600">
          {progressPercent.toFixed(1)}%
        </p>
      </div>

      {/* --- Chart --- */}
      <WeightChart userId={userId} />

      {/* --- Weight history list (read-only) --- */}
      <div className="bg-white p-4 rounded-xl shadow">
        <h3 className="font-bold mb-3">سوابق وزن</h3>

        <ul className="space-y-2 text-sm">
          {weightEntries.map((entry, i) => (
            <li
              key={i}
              className="flex justify-between p-2 bg-gray-50 rounded-lg border">
              <span>{new Date(entry.date).toLocaleDateString('fa-IR')}</span>
              <span className="font-bold">{entry.weight} kg</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function SummaryCard({ title, value }) {
  return (
    <div className="bg-white p-4 shadow rounded-xl text-center">
      <p className="text-gray-500 text-sm">{title}</p>
      <p className="font-bold text-xl mt-1">{value}</p>
    </div>
  );
}
